<div class="modal-content">
  <div class="modal-header">
    <h4 class="modal-title">MENTOR VIRTUAL</h4>
  </div>
  <div class="modal-body">
    <div class="input-group-append">
      <p>O consumo de créditos do <strong>MENTOR VIRTUAL ESCRITHA(MVE)</strong> é considerado um bom investimento para
        pessoas que buscam aumentar o seu rendimento em trabalhos científicos. Ao contratar a licença anual da ESCRITHA,
        o usuário tem direito à <strong>5k de crédito</strong> para utilizar os recursos do MVE. Veja seus créditos na
        lateral esquerda inferior da tela. Para adquirir mais crédito do MVE, basta acessar o botão RENOVAR e
        adquiri-los. Ao <strong>ACEITAR</strong>, seus créditos serão consumidos.</p>
    </div>
    <div class="input-group">
      <input #inputBox placeholder="Digite algumas palavras-chave" type="text" formControlName="title"
        class="form-control mb-8" id="title" minlength="10">
      <button type="button" class="btn-size btn-outline-secondary" id="api-call-btn"
        (click)="generateTitle(inputBox.value)">
        <span *ngIf="!requestAiLoading">Sugerir títulos</span>
        <mat-progress-spinner [mode]="'indeterminate'" [diameter]="25" *ngIf="requestAiLoading"></mat-progress-spinner>
      </button>
      <div class="input-group suggestion-box mb-8">
        <select #suggestions class="form-control select-color" (change)="onSelected(suggestions.value)"
          *ngIf="hasSuggestions()">
          <option [value]="''" disabled selected>Lista das sugestões de títulos</option>
          <option *ngFor="let suggestion of splitedSuggestions" [value]="suggestion">{{suggestion}}</option>
        </select>
      </div>
    </div>
    <div class="modal-footer">
      <button type="button" class="btn btn-link mainFontColor" data-dismiss="modal"
        (click)="activeModal.close()">Fechar</button>
      <button type="button" class="btn btn-primary mainBackground-color" (click)="title()">Aceitar</button>
    </div>
  </div>
